import { Button, InputArea } from '@cloudflare/kumo';
import { useState } from 'react';

/**
 * Painel de notas internas. Backend não tem GET /notes — notas chegam via
 * messages[] do GET /inbox/:id (kind === 'NOTE'). Aqui só criamos.
 */
export function NotesPanel({ onAdd, disabled }: { onAdd: (text: string) => Promise<void> | void; disabled?: boolean }) {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    const t = text.trim();
    if (!t || busy) return;
    setBusy(true);
    try {
      await onAdd(t);
      setText('');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="inbox-notes-panel" data-testid="inbox-notes-panel">
      <InputArea label="Nova nota interna" onChange={(e) => setText(e.target.value)} placeholder="Escreva uma nota interna (só a equipe vê)…" value={text} rows={3} disabled={disabled} />
      <Button variant="primary" onClick={submit} disabled={!text.trim() || busy || disabled} data-testid="inbox-add-note">
        {busy ? 'Salvando…' : 'Adicionar nota'}
      </Button>
    </div>
  );
}
